function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.7100201,6.9998999L13.3500004,1.3499l-0.7000008-0.699998L7.00002,6.2898998L1.3500299,0.649902L0.650024,1.3499 L6.29003,6.9998999L0.650024,12.6499004l0.7000059,0.6999998L7.00002,7.7098999L7.7100201,6.9998999z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.4143906,7.7071853L7.7072873,8.4142904l4.9356036,4.9356098l0.7071095-0.7071104L8.4143906,7.7071853z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      "enableBackground": "new 0 0 14 14"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/close.0e2aa836.svg";
export { SvgComponent as ReactComponent };